import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AppType, isInternalAppType, parseAppType } from "@azm/core/enums/app-types";
import { resolveInternalHomeUrl } from "@azm/core/guards/internal-home";
import { UserRoles } from "@azm/core/enums/user-roles";
import { AuthService } from "@azm/core/services/auth";
import { SidebarService } from "@azm/core/services/sidebar";

import { environment } from "@azm/environments/environment";

const roleRoutes: Partial<Record<UserRoles, string>> = {
	[UserRoles.Business]: "/business",
	[UserRoles.Individual]: "/individual",
	[UserRoles.Government]: "/government",
};

export const authGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const authService = inject(AuthService);
	const sidebarService = inject(SidebarService);

	let appType: AppType | null;
	try {
		const raw = localStorage.getItem(environment.appTypePropertyName);
		appType = raw ? parseAppType(atob(raw)) : null;
	} catch {
		appType = null;
	}

	if (appType !== environment.defaultAppType && authService.isAuthenticated && !state.url.includes("error")) {
		router.navigate(["/error/403"]);
		return false;
	}

	const nav = router.currentNavigation();
	const isLanding = nav?.extras?.state?.["isLanding"] ?? route.data["isLanding"];
	const activeRoute = roleRoutes[authService.userRole as UserRoles];

	if (authService.isAuthenticated) {
		if (isLanding) {
			if (authService.isInternalUser || isInternalAppType(environment.defaultAppType)) {
				return resolveInternalHomeUrl(authService, sidebarService, router);
			}
			const target = activeRoute ?? "/";
			void router.navigate([target]);
			return false;
		}

		if (route.data["role"] && route.data["role"] !== authService.userRole) {
			router.navigate(["error/403"]);
			return false;
		}
	} else {
		if (!isLanding && typeof isLanding === "boolean") {
			if (state.url.includes("admin")) router.navigate(["/auth/admin"]);
			else router.navigate(["/"]);
			return false;
		}
	}

	return true;
};
